export enum AssertionScoreStatus {
    PASS = "pass",
    CLOSE = "close",
    PARTIAL = "partial",
    UNVERIFIED = "unverified",
    FAIL = "fail",
    WARN = "warn"
}
